/**
 * Frontend Configuration
 * Feature flags and environment-specific settings
 */

// Validate environment variables in production
const STAGE_FALLBACK_URL = 'https://api-stage.ally.ai'

let resolvedApiBaseUrl = import.meta.env.VITE_API_BASE_URL
if (import.meta.env.PROD && !resolvedApiBaseUrl) {
  console.warn(
    '⚠️ VITE_API_BASE_URL missing during production build. ' +
    `Falling back to ${STAGE_FALLBACK_URL}. ` +
    'Set VITE_API_BASE_URL as a Cloudflare Pages build variable to override.'
  )
  resolvedApiBaseUrl = STAGE_FALLBACK_URL
}

// Debug: Log the environment variable value (only in production to help diagnose)
if (import.meta.env.PROD) {
  console.log('🔍 Environment Debug:', {
    VITE_API_BASE_URL: resolvedApiBaseUrl,
    MODE: import.meta.env.MODE,
    PROD: import.meta.env.PROD,
  });
}

export const config = {
  // API base URL (defaults to localhost:5000 for development)
  // In production, this MUST be set via VITE_API_BASE_URL environment variable
  apiBaseUrl: resolvedApiBaseUrl || 'http://localhost:5000',
};

// Log the final API base URL being used
if (import.meta.env.PROD) {
  console.log('🌐 Using API Base URL:', config.apiBaseUrl);
}

export default config;

